import React, {useCallback, useState} from 'react'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import {ThemeProvider} from 'styled-components'
import {UseWalletProvider} from 'use-wallet'
import FarmsProvider from './contexts/Farms'
import ModalsProvider from './contexts/Modals'
import KiraProvider from './contexts/KiraProvider'
import theme from './theme'
import Farms from './views/Farms'
import Home from './views/Home'
import config from './config'
import Nav from "./components/TopBar/components/Nav";

const App: React.FC = () => {
  const [mobileMenu, setMobileMenu] = useState(false)

  const handleDismissMobileMenu = useCallback(() => {
    setMobileMenu(false)
  }, [setMobileMenu])

  const handlePresentMobileMenu = useCallback(() => {
    setMobileMenu(true);
  }, [setMobileMenu])

  return (
    <Providers>
      <Router>
        <Nav />
        {/* <MobileMenu onDismiss={handleDismissMobileMenu} visible={mobileMenu} /> */}
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/pools">
            <Farms />
          </Route>
          <Route path="/reward">
            <Farms />
          </Route>
        </Switch>
      </Router>
    </Providers>
  )
}

const Providers: React.FC = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <UseWalletProvider
        chainId={config.NETWORK === "polygon-mainnet" ? 137 : 1337}
        connectors={{
          walletconnect: { rpcUrl:  config.NETWORK === "polygon-mainnet" ? ' https://rpc-mainnet.maticvigil.com/' : 'https://rpc-mumbai.maticvigil.com/' },
        }}
      >
        <KiraProvider>
          <FarmsProvider>
            <ModalsProvider>{children}</ModalsProvider>
          </FarmsProvider>
        </KiraProvider>
      </UseWalletProvider>
    </ThemeProvider>
  )
}

export default App
